'use strict';

var Utils = require('../utils/utils');
// require('stickyfill');

require('./stickyfill/stickyfill');

// Constructor
var StickyElement = function() {

  var self = this;

  self.config = {
    'element'        :  $('[data-sticky-element]'),
    'defaultOffset'  :  90
  }

  var $element       =  self.config.element;
  var defaultOffset  =  self.config.defaultOffset;

  self.StickyOptions = function() {
    this.offset_top = defaultOffset;
  }

  self.stickElement = function() {

    $element.each(function() {
      var $this = $(this);

      // Stickyfill.add($this[0]);
      $this.Stickyfill();
      /*
      var $this = $(this);
      var options = new self.StickyOptions();

      if ($this.attr('data-sticky-parent')) {
        var parent = $this.attr('data-sticky-parent');
        options.parent = parent;
      }

      if ($this.attr('data-sticky-offset')) {
        var offset = parseInt($this.attr('data-sticky-offset'));
        options.offset_top = offset;
      }

      $this.stick_in_parent(options);
      */
    });
  }

  self.unstickElement = function() {
    // $element.trigger('sticky_kit:detach');
  }

  // self.forceRecalc = function() {
  //   $(document.body).trigger('sticky_kit:recalc');
  // }

  self.init = function() {

    var largeViewports = function() {
      self.stickElement();
    };

    var smallViewports = function() {
      self.unstickElement();
    };

    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
  }
};

module.exports = StickyElement;
